import React, { useState } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import {
    getAllApplications,
    searchApplication
} from "../../../api/apiServices";
import Pagination from '../../../services/Pagination';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Loader from "../../Common/Spinner/Loader";
import toast, { Toaster } from 'react-hot-toast'
import { format } from "date-fns";
const dateFormat = "dd-MM-yyyy";

const Applications = (regional_email) => {

    const params = useParams();
    const id = params.id ? params.id : undefined

    const [search, setSearch] = useState(false);
    const [application, setApplication] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(20);

    const {
        isLoading,
        isError,
        error,
        data: applications,
    } = useQuery(['applications', regional_email], () => getAllApplications(regional_email), {
        select: data => data.sort((a, b) => b.id - a.id),
        keepPreviousData: true,
    });

    let total_applications = applications?.length

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/new_applications";

    const [mobile_number, setMobileNumber] = useState(null);
    const [first_name, setFirstName] = useState(null);
    const [last_name, setLastName] = useState(null);

    const handleSearch = async (e) => {
        e.preventDefault();

        const searchData = {
            mobile_number: mobile_number,
            first_name: first_name,
            last_name: last_name,
        }

        try {
            await searchApplication(searchData).then((res) => {
                if (res.length > 0) {
                    setApplication(res)
                    setSearch(true)
                    setMobileNumber(null)
                    setFirstName(null)
                    setLastName(null)
                }
            }).catch((err) => {
                console.log("Why", err)
                toast.error("Provide at least one search parameter ")
                return false
            })
        } catch (err) {
            toast.error(err)
        }
    }

    let currentPosts = []
    const indexOfLastPage = currentPage * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    if (!search) {
        currentPosts = applications?.slice(indexOfFirstPage, indexOfLastPage);
    } else {
        currentPosts = application?.slice(indexOfFirstPage, indexOfLastPage);
    }

    const handleCancel = () => {
        setMobileNumber("");
        setFirstName("");
        setLastName("");
        setSearch(false);
        navigate(from, { replace: true });
    }

    let searchContent = (
        <form onSubmit={handleSearch} >
            <div className="form-group row">
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        // style={{ textTransform: "uppercase" }}
                        placeholder="Mobile Number"
                        onChange={(e) => setMobileNumber(e.target.value)}
                        value={mobile_number}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="FirstName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setFirstName(e.target.value)}
                        value={first_name}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="LastName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setLastName(e.target.value)}
                        value={last_name}
                    />
                </div>
                <div className="col-sm-3">
                    <button
                        type="submit"
                        className="btn btn-success btn-block "
                    > <i className="fa fa-search"></i> Search Application
                    </button>
                </div>
            </div>
        </form>
    )

     let content;
     if (isLoading) {
       content = (
         <div className="loader">
           <p>Loading new applications. Please wait...</p>
           <Loader />
         </div>
       );
     } else if (isError) {
       content = <p>{error.message}</p>;
     } else {
       content = currentPosts && currentPosts?.length <= 0 ? (
           <div className="table-responsive lg table-wrapper">
             <table className="table table-borderless table-striped">
               <tbody>
                 <tr>
                   <td
                     style={{
                       fontSize: "20px",
                       fontWeight: "700",
                       color: "#000",
                       textAlign: "center",
                     }}
                   >
                     There are no application(s)
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
         ) : (
           <>
             <div className="table-responsive lg">
               <table className="table table-borderless table-striped">
                 <thead className="align">
                   <tr>
                     <th scope="col">#</th>
                     <th scope="col">Full Name</th>
                     <th scope="col">Region</th>
                     <th scope="col">Mobile</th>
                     <th scope="col" style={{ whiteSpace: "nowrap" }}>
                       Application Date
                     </th>
                     <th scope="col">Profession</th>
                   </tr>
                 </thead>
                 <tbody>
                   {currentPosts?.map((mem, index) => (
                     <tr key={index}>
                       <td>{postPerPage * (currentPage - 1) + index + 1}</td>
                       <td style={{ whiteSpace: "nowrap" }}>
                         {mem.title}&nbsp;{mem.first_name}&nbsp;
                         {mem.middle_name}&nbsp;{mem.last_name}
                       </td>
                       <td style={{ whiteSpace: "nowrap" }}>{mem.region}</td>
                       <td style={{ whiteSpace: "nowrap" }}>
                         {mem.mobile_number}
                       </td>
                       <td style={{ whiteSpace: "nowrap" }}>
                         {format(new Date(mem.date_joined), dateFormat)}
                       </td>
                       <td>{mem.profession}</td>
                     </tr>
                   ))}
                 </tbody>
               </table>
             </div>
           </>
         );
     }


    return (
        <><section className="content-header">
            <Toaster toastOptions={{ position: "top-center" }} />
            <h1>Applications : New Applications - {total_applications}</h1>
        </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span> {currentPosts && currentPosts?.length > 0 ? searchContent : null}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                {currentPosts?.length > 0 && !search ? (
                                    <Pagination
                                        data={applications}
                                        postPerPage={postPerPage}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        setPostPerPage={setPostPerPage} />
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="box-body"></div>
                </div>
            </section></>
    );
}

export default Applications;


